import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';

import { Environment } from 'src/environments/environment.model';

import { StateActiveIngredientSetting } from '../activeingredientsetting.model';

@Injectable({
  providedIn: 'root',
})
export class ActiveIngredientSettingsService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl =
    this.env.API_BASE_URL + '/service/planet-proof/secure/activeingredientsetting/';

  getActiveIngredientSettings(): Observable<StateActiveIngredientSetting[]> {
    return this.http.get<StateActiveIngredientSetting[]>(this.baseUrl);
  }

  getActiveIngredientSetting(id: number): Observable<StateActiveIngredientSetting> {
    return this.http.get<StateActiveIngredientSetting>(`${this.baseUrl}${id}`);
  }

  upsertActiveIngredientSettings(activeIngredientSetting: StateActiveIngredientSetting) {
    return this.http.post<StateActiveIngredientSetting>(`${this.baseUrl}`, activeIngredientSetting);
  }

  deleteActiveIngredientSetting(activeIngredientSetting: StateActiveIngredientSetting) {
    return this.http.delete<StateActiveIngredientSetting>(
      `${this.baseUrl}${activeIngredientSetting.id}`,
    );
  }
}
